// 订单状态枚举
export enum orderStatusEnum {
    DELETE = -2, // 已删除
    CANCEL = -1, // 已取消
    WAIT_PAY = 1, // 待支付
    WAIT_SEND = 2, // 待发货
    WAIT_RECEIVE = 3, // 待收货
    SUCCESS = 4, // 已完成（确认收货）
    SUCCESSSEVEN = 41, // 已完成（7天内）
    SUCCESSSEVENFIC = 42, // 已完成（7天内 虚拟商品）
    APPLY_REFUND = 5, // 退款申请中    虚拟商品要考虑
    REFUSE_REFUND = 6, // 拒绝退款
    CONFIRM_REFUND = 7, // 已退款     虚拟商品要考虑
    COMMENTED = 8, // 已评价
    ERROR = 9,
    TAKE_DELIVERY = 44, // 已收货
    ALL = 100 // 全部
}

export enum payReturnUrl {
    type = 0
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/status.ts